<dialog #promoDialog *transloco="let t">
  <button
    app-button="icon-button"
    class="close-button"
    (click)="close()"
    [attr.aria-label]="t('Close')"
  >
    <svg-icon key="close" size="md"></svg-icon>
  </button>
  @if (popupContent) {
    <div class="content">
      <h3 [innerHTML]="popupContent.title"></h3>
      <p [innerHTML]="popupContent.description"></p>
      <a [routerLink]="popupContent.urlTarget | addLocale" autofocus>
        {{ popupContent.buttonText }}
      </a>
    </div>
  }
</dialog>
